(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("fedops-logger", [], factory);
	else if(typeof exports === 'object')
		exports["fedops-logger"] = factory();
	else
		root["fedops-logger"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 